angular.module('impactx.search').component('ixProductItemPrice', {
        bindings: {
            product: '<',
            trns: '<'
        },
        controller: 'ProductItemPriceCtrl',
        controllerAs: 'priceCtrl',
        templateUrl: 'modules/search/templates/product-item-price.html'
    }
);